module.exports = __webpack_public_path__ + "static/valerie-chavot-massage-04286347aa41205f0ec309f90fd81ab7.jpg";